/**
 * Author: Andrey Morozov
 * Confidential. Proprietary and confidential. Unauthorized copying or distribution is prohibited.
 */

import { DesignSystemProvider, LegalNotice } from "@iam/design-system";
import { I18nProvider } from "@iam/design-system/i18n";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AuthGate } from "./auth/AuthGate";
import { CONSOLE_MESSAGES } from "./i18n/catalog";
import "./styles.css";

/**
 * ConsoleRoot composes the persistent shared I18nProvider with the console's
 * RU/EN catalogs. Browser preference and explicit user choice determine locale.
 */
function ConsoleRoot() {
  return (
    <DesignSystemProvider theme="dark">
      <I18nProvider messages={CONSOLE_MESSAGES}>
        <AuthGate>{(session) => <App session={session} />}</AuthGate>
        <LegalNotice serviceKey="iam-core" />
      </I18nProvider>
    </DesignSystemProvider>
  );
}

const root = document.getElementById("root");
if (!root) throw new Error("Root #root not found");

createRoot(root).render(
  <StrictMode>
    <ConsoleRoot />
  </StrictMode>,
);
